import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { VALIDATION_ERROR_MESSAGE } from 'app/constants/admin/browse/home';
import { parseListUrl } from 'app/helpers/admin/browse/home';
import useListApi from 'app/hooks/useListApi';
import { listUrlShape } from 'app/shapes/admin/browse/home';
import EditorUrl from './EditorUrl';

const ERROR_MESSAGE_INVALID_LIST_URL = 'List URL is invalid';
const ERROR_MESSAGE_FAILED_TO_FETCH_LIST = 'Could not request information about this list (it may be private)';

const EditorListUrl = ({ errorMessage: validationErrorMessage, onCancel, listUrl, onChange }) => {
  const { url } = listUrl;

  const { fetchList } = useListApi();

  const [state, setState] = useState({
    errorMessage: validationErrorMessage || '',
    isFetching: false
  });
  const { errorMessage, isFetching } = state;

  useEffect(() => {
    setState(prevState => {
      return {
        ...prevState,
        errorMessage: validationErrorMessage
      };
    });
  }, [validationErrorMessage]);

  const handleListUrlChange = newListUrl => {
    const { listId, subdomain } = parseListUrl(newListUrl) || {};

    if (listId && subdomain) {
      setState(prevState => {
        return {
          ...prevState,
          isFetching: true
        };
      });
      fetchList(listId, subdomain)
        .then(list => {
          onChange({
            title: list.title,
            url: newListUrl
          });
        })
        .catch(() => {
          setState(prevState => {
            return {
              ...prevState,
              errorMessage: ERROR_MESSAGE_FAILED_TO_FETCH_LIST
            };
          });
        })
        .finally(() => {
          setState(prevState => {
            return {
              ...prevState,
              isFetching: false
            };
          });
        });
    } else {
      setState(prevState => {
        return {
          ...prevState,
          errorMessage: ERROR_MESSAGE_INVALID_LIST_URL
        };
      });
    }
  };

  return (
    <div>
      <EditorUrl
        errorMessage={errorMessage}
        invalidUrlMessage={VALIDATION_ERROR_MESSAGE.INVALID_LIST_URL}
        isEnabled={!isFetching}
        isLoading={isFetching}
        label="List URL"
        onCancel={onCancel}
        onChange={handleListUrlChange}
        url={url}
      />
    </div>
  );
};

EditorListUrl.defaultProps = {
  errorMessage: ''
};

EditorListUrl.propTypes = {
  errorMessage: PropTypes.string,
  listUrl: listUrlShape.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default EditorListUrl;
